<template>
  <div>
    <v-card width="6000">
      <v-card-title>
        <DialogTitle :dialogName="$options.name">
          Billing Groups
        </DialogTitle>
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          :items-per-page="10"
          :footer-props="{
            'show-first-last-page': true
          }"
          :headers="headers"
          :items="infoList"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:item.BillAsInvoice="{ item }">
            <v-icon v-if="item.BillAsInvoice" color="success">
              {{ icon.lineItemIsChecked }}
            </v-icon>
          </template>
          <template v-slot:item.IsAutoBill="{ item }">
            <div v-if="item.IsAutoBill">
              {{
                formatFrequency(
                  item.FrequencyInfo.RecurPeriod,
                  item.FrequencyInfo.RecurOption,
                  item.FrequencyInfo.Interval1,
                  item.FrequencyInfo.Interval2,
                  item.FrequencyInfo.Interval3
                )
              }}
            </div>
          </template>
          <template v-slot:item.IsDeleted="{ item }">
            <v-icon v-if="item.IsDeleted" color="error">
              {{ icon.lineItemIsDeleted }}
            </v-icon>
          </template>
          <template v-slot:item.Actions="{ item }">
            <v-icon small class="mr-2" @click="editItemClick(item)">
              {{ icon.lineItemEdit }}
            </v-icon>
            <v-icon small @click="deleteItemClick(item)">
              {{ icon.lineItemDelete }}
            </v-icon>
          </template>
        </v-data-table>
        <div class="table-footer-prepend d-flex pl-2 align-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="newItemClick">
                <v-icon>{{ icon.lineItemAdd }}</v-icon>
              </v-btn>
            </template>
            <span>New Billing Group</span>
          </v-tooltip>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="showEditorDialog" width="900" persistent>
      <BillingGroupEditor
        :infoId="selectedItemId"
        :isDialogOpen="showEditorDialog"
        @close="editorCloseEvent"
        @update="editorUpdateEvent"
      />
    </v-dialog>
    <DialogUtil ref="dialogUtil" />
  </div>
</template>
<script>
import { ref, watch } from 'vue'
import { icon } from '@/use/Constants'
import { host } from '@/services/HostAPI'
import { formatFrequency } from '@/use/FrequencyFormatter'
import BillingGroupEditor from '@/components/Setup/Billing/BillingGroupEditor'
export default {
  name: 'BillingGroupList',
  props: {
    isDialogOpen: {
      type: Boolean,
      default: false
    }
  },
  components: { BillingGroupEditor },
  setup(props) {
    const dialogUtil = ref(null)
    const loading = ref(false)

    watch(
      () => props.isDialogOpen,
      newVal => {
        newVal && initDialog()
      }
    )

    const initDialog = () => {
      infoList.value = []
      getBillingGroupList()
    }

    const infoList = ref([])
    const selectedItemId = ref(null)
    const showEditorDialog = ref(false)

    const getBillingGroupList = async () => {
      loading.value = true
      const rq = {}
      const rs = await host.billingGroup.list(rq)
      infoList.value = rs.InfoList
      loading.value = false
    }

    function editItemClick(item) {
      selectedItemId.value = item.BillingGroupId
      showEditorDialog.value = true
    }

    function deleteItemClick(item) {
      dialogUtil.value
        .confirm({
          title: 'Please confirm',
          text: `Delete Billing Group ${item.Description}`
        })
        .then(() => performDeleteBillingGroup(item))
        .catch(() => {
          return
        })
    }

    async function performDeleteBillingGroup(item) {
      const rq = { InfoId: item.BillingGroupId }
      const rs = await host.billingGroup.delete(rq)
      if (rs.IsSuccess) {
        getBillingGroupList()
      } else {
        dialogUtil.value.error(rs.Message)
      }
    }

    function newItemClick() {
      selectedItemId.value = null
      showEditorDialog.value = true
    }

    const headers = [
      { value: 'Description', text: 'Description' },
      { value: 'BillAsInvoice', text: 'Bill as Invoice', align: 'center' },
      { value: 'IsAutoBill', text: 'Auto Bill' },
      { value: 'IsDeleted', text: 'Deleted', align: 'center' },
      { value: 'Actions', text: 'Actions', sortable: false, width: 60 }
    ]

    const editorCloseEvent = () => {
      showEditorDialog.value = false
    }

    const editorUpdateEvent = () => {
      showEditorDialog.value = false
      getBillingGroupList()
    }

    initDialog()

    return {
      dialogUtil,
      infoList,
      headers,
      showEditorDialog,
      selectedItemId,
      editItemClick,
      deleteItemClick,
      newItemClick,
      editorCloseEvent,
      editorUpdateEvent,
      formatFrequency,
      icon,
      loading
    }
  }
}
</script>

<style lang="scss" scoped></style>
